import React from 'react'

const StakeholderDashboard = () => {
    return (
        <div>
            <div className="dashboard-control-panel">
                This is the stakeholder Dashboard
            </div>
        </div>
    )
}

export default StakeholderDashboard;
